import React from "react";
import { View, StyleSheet } from "react-native";

import CustomText from "../../../common/general/CustomText/CustomText";

interface StatBadgeProps {
  label: string;
  value: string | number;
  color: string;
}

const StatBadge: React.FC<StatBadgeProps> = ({ label, value, color }) => (
  <View style={[styles.statBadge, { backgroundColor: color + "20", borderColor: color }]}>
    <CustomText text={`${label}: ${value}`} size="xs" style={{ color }} useTranslationText={false} />
  </View>
);

const styles = StyleSheet.create({
  statBadge: {
    paddingHorizontal: 6,
    paddingVertical: 2,
    borderRadius: 8,
    borderWidth: 1,
    marginRight: 4,
    marginBottom: 4,
  },
});

export default StatBadge;
